import { Button, Grid, IconButton, Paper, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { errorModalClasses, StyledErrorModal } from "./StyledErrorModal";

interface IErrorModalProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    onClose?: () => void;
    text: string;
}

export const ErrorModal = (props: IErrorModalProps) => {
    return (
        <StyledErrorModal
            open={props.open}
            className={errorModalClasses.root}
            onClose={() => {
                if (props.onClose) {
                    props.onClose();
                }
            }}>
            <Paper className={errorModalClasses.paper}>
                <Grid container flexDirection={"row"} alignItems={"center"} justifyContent={"space-between"}>
                    <Typography>{props.text}</Typography>
                    <IconButton
                        onClick={() => {
                            props.setOpen(false);
                            if (props.onClose) {
                                props.onClose();
                            }
                        }}>
                        <CloseIcon />
                    </IconButton>
                </Grid>
                <Grid container display={"flex"} flexDirection={"row"} justifyContent={"center"}>
                    <Button
                        variant={"contained"}
                        color={"secondary"}
                        className={errorModalClasses.acceptButton}
                        onClick={() => {
                            props.setOpen(false);
                            if (props.onClose) {
                                props.onClose();
                            }
                        }}>
                        Добре
                    </Button>
                </Grid>
            </Paper>
        </StyledErrorModal>
    );
};
